import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const duxInspectionRequestColumns: GridColumnConfig[] = [
  {
    title: 'Work Order Number',
    field: 'workOrderNumber',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Pre Requisite Required',
    field: 'preRequisiteRequired',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'workOrderStatus',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Inspection Request Type',
    field: 'inspectionRequestType',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  // {
  //   title: 'Customer Name',
  //   field: 'customerName',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width: '260'
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  // {
  //   title: 'Builder Job Number',
  //   field: 'jobNumber',
  //   filter: 'text',
  //   width: '180',
  //   searchable: true,
  // },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  // {
  //   title: 'Service Code',
  //   field: 'serviceCode',
  //   filter: 'text',
  //   width: '200',
  //   searchable: true,
  // },
  // {
  //   title: 'Inspector Name',
  //   field: 'inspectorName',
  //   filter: 'text',
  //   width: '180',
  //   searchable: true,
  // },
  // {
  //   title: 'Created On',
  //   field: 'workorderCreatedOn',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  {
    title: 'Status Updated On',
    field: 'workOrderLastStatusUpdatedOn',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Proposed Scheduled Date',
    field: 'proposedScheduledDate',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  // {
  //   title: 'Scheduled Date',
  //   field: 'scheduledDate',
  //   filter: 'text',
  //   width: '180',
  //   searchable: true,
  // },
  // {
  //   title: 'Completed On',
  //   field: 'completedOn',
  //   filter: 'text',
  //   width: '180',
  //   searchable: true,
  // },
  // {
  //   title: 'Waived On',
  //   field: 'waivedOn',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  // {
  //   title: 'Cancelled On',
  //   field: 'cancelledOn',
  //   filter: 'text',
  //   width: '220',
  //   searchable: true,
  // },
  {
    title: 'Inspection Requested From',
    field: 'inspectionRequestedFrom',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Inspection Requested On',
    field: 'inspectionRequestOn',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Inspection Requested By',
    field: 'inspectionRequestContactName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  // {
  //   title: 'Price ($)',
  //   field: 'priceNumeric',
  //   filter: 'numeric',
  //   width: '180',
  //   searchable: true,
  //   format: '{0:n2}',
  // },
  {
    title: 'Invoice Amount ($)',
    field: 'invoiceAmountNumeric',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  {
    title: 'Accrual Amount ($)',
    field: 'accrualAmountNumeric',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  {
    title: 'Permit Number',
    field: 'permitNumber',
    filter: 'text',
    searchable: true,
    width: '160',
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Unit Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
];
